import { Tag, type TagProps, Text, theme } from '@/components';
import { CloseOutlined } from '@ant-design/icons';
import type { FC, ReactNode } from 'react';

type Props = {
  label: string | ReactNode;
  icon?: ReactNode;
} & Pick<TagProps, 'onClose' | 'closable' | 'color'>;

export const SearchFilterTag: FC<Props> = ({
  label,
  icon,
  closable,
  onClose,
  color,
}) => {
  const { token } = theme.useToken();
  return (
    <Tag
      closable={closable}
      onClose={onClose}
      closeIcon={
        closable ? (
          <CloseOutlined
            style={{
              color: token.colorTextBase,
              marginLeft: 8,
              fontSize: token.fontSize,
            }}
          />
        ) : undefined
      }
      style={{
        color: token.colorTextBase,
        padding: 8,
        fontSize: token.fontSize,
        margin: 0,
        whiteSpace: 'normal',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        height: 'auto',
      }}
      color={color ?? token.colorPrimaryBg}
      icon={icon}
      data-dd-privacy="allow"
    >
      {typeof label === 'string' ? (
        <Text
          maxWidth="30em"
          text={label}
          style={{
            overflowWrap: 'break-word',
            wordBreak: 'break-all',
            whiteSpace: 'normal',
            maxWidth: '100%',
          }}
        />
      ) : (
        label
      )}
    </Tag>
  );
};
